import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef, 
  Inject
} from '@angular/core';
import {
  IClinicalTrendsListConfig,
  IClinicalTrendType
} from "@ispm-client/modules/clinical-dashboard/interfaces/clinica-trends.interface";

import {get, uniqBy, set, groupBy, cloneDeep, isEmpty} from 'lodash';
import {InterpolateService} from "@ispm/shared/services/interpolate.service";
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
  selector: 'ispm-clinical-trends-list',
  templateUrl: './clinical-trends-list.component.html',
  styleUrls: ['./clinical-trends-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClinicalTrendsListComponent implements OnInit {
  public data: any;
  public _types: Array<IClinicalTrendType>;
  private selectedItems = [];
  public showListPanel: boolean = true;
  private trendsSelectedItemsMapKey = 'trendsSelectedItems';
  @Output()
  itemSelectEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  onChangeTogglePanel: EventEmitter<boolean> = new EventEmitter();

  @Input() set types(_types: Array<IClinicalTrendType>) {
    this._types = cloneDeep(_types);
    this.selectedItems = [];
    if (this._types && Array.isArray(this._types) && this._types.length > 0) {
      this.trendsSelectedItemsMapKey = 'trendsSelectedItems';
      let selectedClinicalDashboard = sessionStorage.getItem("selectedClinicalDashboard");

      if (selectedClinicalDashboard) {
        this.trendsSelectedItemsMapKey = this.trendsSelectedItemsMapKey + selectedClinicalDashboard.toLowerCase().replace(" ", "");
      }
      let selectedItemKeysString = sessionStorage.getItem(this.trendsSelectedItemsMapKey);
      let selectedItemKeys = [];
      if (selectedItemKeysString) {
        selectedItemKeys = selectedItemKeysString.split(',');
      }
      for (let index = 0; index < this._types.length; index++) {
        let type = _types[index];
        let data = get(type, 'data');
        if (!isEmpty(data)) {
          let labels = data.map(item => {
            let displayName = this._interpolateService.interpolate(get(type, 'displayPattern'), item, null, {
              useEmptyValues: false,
              usePartialPath: false,
              clearUnresolvedPatterns: true
            });
            let tooltipText = this._interpolateService.interpolate(get(type, 'tooltipDisplayPattern'), item, null, {
              useEmptyValues: false,
              usePartialPath: false,
              clearUnresolvedPatterns: true
            });
            return {
              'name': get(item, get(type, 'labelPath')),
              'displayName': displayName.replace("()", ""),
              'tooltipText': tooltipText ? tooltipText.replace("()", ""): ""
            }
          });
          labels = uniqBy(labels, `name.${get(type, 'codePath')}`);
          if (labels && labels.length > 0) {
            let prettyLabels = [];
            for (let label of labels) {
              let selected = true;
              let itemKey = get(label, `name.${get(type, 'codePath')}`);
              if (get(this.listConfig, 'maxSelection') && this.selectedItems.length === get(this.listConfig, 'maxSelection')) {
                selected = false;
              } else if (itemKey) {
                if ((Array.isArray(selectedItemKeys) && selectedItemKeys.length > 0 && !selectedItemKeys.includes(itemKey))) {
                  selected = false;
                } else {
                  this.selectedItems.push({type: type.type, itemKey: itemKey});
                }
              }

              prettyLabels.push({
                "key": itemKey,
                "value": get(label, `name.${get(type, 'displayPath')}`),
                "displayName": get(label, `displayName`),
                "tooltipText": get(label,`tooltipText`,get(label, `displayName`)),
                "selected": selected
              })
            }
            set(type, 'prettyLabels', prettyLabels);
            this._types.splice(index, 1, type);
          }
        }
      }
      this.emitSelectedItems(true);
    }
  };

  @Input() listConfig: IClinicalTrendsListConfig;
  _searchText: string = '';
  public set searchText(_searchText: string) {
    if (_searchText != this._searchText) {
      this._searchText = _searchText;
      this._types = cloneDeep(this._types);
      this._cd.markForCheck();
    }
  };
  public placeHolderText: string = 'Search...'

  constructor(private _interpolateService: InterpolateService,
              private _cd: ChangeDetectorRef,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE) {
  }


  ngOnInit(): void {
  }

  onSelected(event, type, label) {
    let isChecked = event.target.checked;
    let itemIndex = this.selectedItems.findIndex(item => item.itemKey === label.key);
    if (get(this.listConfig, 'maxSelection') && this.selectedItems && this.selectedItems.length == get(this.listConfig, 'maxSelection')) {
      if (isChecked) {
        event.target.checked = false;
        this.notificationMessageService.warning(this.notificationMessage.TRENDS_MAX_SELECTION);
      } else {
        this.selectedItems.splice(itemIndex, 1);
        this.itemSelectEmitter.emit({selectedItems: groupBy(this.selectedItems, 'type')});
      }
      return;
    }
    if (event) {
      if (isChecked) {
        this.selectedItems.push({type: type.type, itemKey: label.key});
      } else {
        this.selectedItems.splice(itemIndex, 1);
      }
      this.emitSelectedItems(false);
    }
  }


  /**
   * Toggle side panel
   */
  showHideListPanel() {
    this.showListPanel = !this.showListPanel;
    this.onChangeTogglePanel.emit(this.showListPanel);
  }

  /**
   * filter trends list
   */
  public filterTrends = function (item) {
    if (!this._searchText) {
      return true;
    }
    const itemString = get(item, 'displayName', '').toLowerCase();
    return itemString.includes(this._searchText.toLowerCase());
  }.bind(this);

  /**
   * Emit selected items
   */
  private emitSelectedItems(isInit) {
    if ((isInit && this.selectedItems.length > 0) || !isInit) {
      sessionStorage.setItem(this.trendsSelectedItemsMapKey, this.selectedItems.map(item => get(item, 'itemKey')).toString());
    }
    this.itemSelectEmitter.emit({selectedItems: groupBy(this.selectedItems, 'type')});
  }
}

